import React from 'react';
import { func, shape, string } from 'prop-types';

import {
  Heading,
  Button,
  Paragraph,
  Block,
  Link,
} from 'components/common';
import { FlexContainer } from '@hyphengroup/cag-components';

import './NoResultsIndicator.scss';

const NoResultsIndicator = ({ onResetFilters, labels, recommendationData }) => {
  const { noResultsTitle, noResultsSubHeader, noResultsReset } = labels;

  return (
    <div className="no-results-indicator" data-selector-type="no-results-indicator" data-testid="no-results-found">
      <Block>
        <Heading primary as="h2">{noResultsTitle}</Heading>
        <Paragraph>{noResultsSubHeader}</Paragraph>
        <FlexContainer justifyContent="center">
          {onResetFilters && (
            <Button styleName="ghost" onClick={onResetFilters}>
              {noResultsReset}
            </Button>
          )}
          {recommendationData?.href && (
            <Link to={recommendationData?.href} target="_self">
              <Button styleName="normal secondary" dataSelectorId="no-result-recommendation-btn">
                {recommendationData?.title}
              </Button>
            </Link>
          )}
        </FlexContainer>
      </Block>
    </div>
  );
};

NoResultsIndicator.propTypes = {
  onResetFilters: func,
  labels: shape({
    title: string,
    subHeader: string,
    reset: string,
  }),
  recommendationData: shape({
    title: string,
    href: string,
  }),
};

NoResultsIndicator.defaultProps = {
  onResetFilters: null,
  labels: {},
  recommendationData: null,
};

export default NoResultsIndicator;
